export default __webpack_public_path__ + "static/media/PE.83cbe7a2.svg";